import { UseDialogActionReturn, LocalizedText } from '@mews/framework';
import { Button, Dialog, Stack } from '@optimus-web/core';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { LocalizedTypography } from '@mews-commander/ui';

export const CancelFuturePaymentDialog = ({ actions }: { actions: UseDialogActionReturn }) => (
    <Dialog
        size="small"
        title={<LocalizedText textKey={TextKey.CancelFuturePaymentTitle} />}
        active={actions.states.isDialogOpened}
        onClose={() => actions.handlers.handleCancel()}
        loading={actions.states.isProcessing}
        footer={{
            primary: (
                <Button
                    variant="primary"
                    onClick={async () => await actions.handlers.handleConfirm()}
                    type="submit"
                    data-test-id={DataTestId.ConfirmCancelFuturePaymentPlanPaymentButton}
                >
                    <LocalizedText textKey={TextKey.CancelFuturePaymentConfirmButton} />
                </Button>
            ),
            secondary: (
                <Button onClick={() => actions.handlers.handleCancel()} type="submit">
                    <LocalizedText textKey={TextKey.GoBack} />
                </Button>
            ),
        }}
    >
        <Stack vertical spacing="300">
            <LocalizedTypography textKey={TextKey.CancelFuturePaymentDialogContent} textStyle="bodyLarge" as="div" />
            <LocalizedTypography textKey={TextKey.GeneralThisActionCannotBeUndone} textStyle="bodyLarge" as="div" />
        </Stack>
    </Dialog>
);
